import React from "react";
import styles from "./GuestAssistanceSection.module.css";
import travelimgs from "../../../Images/guestAssistance_img.png";

const GuestAssistanceSection = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Always-On Guest Assistance
            </h2>
            <p>
                Resolve queries, complaints, and service requests instantly via AI-powered <br />
                chat and voice agents.
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Instant responses across channels</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Multilingual support</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>AI handling FAQs and complex queries</h4>
                        </div>
                    </div>
                    <div className={styles.buttons}>
                        <button className={styles.primaryBtn} >Activate 24/7 Support</button>
                    </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className={styles.right}>
                    <img src={travelimgs} alt="travel cancellation" />
                </div>
            </div>
        </section>
    );
};

export default GuestAssistanceSection;
